<div class="mbm-form-group-column">
  @if (labelKey()) {
    <ion-label class="mbm-form-label">
      {{ labelKey()! | translate }}
      @if (isRequired() && showRequiredIndicator()) {
        <img class="mbm-required-indicator" src="assets/icons/asterisk.svg" alt="" aria-hidden="true">
      }
    </ion-label>
  }
  <div class="mbm-form-field-wrapper mbm-textbox-field" [class.mbm-form-field-wrapper-error]="errorMessage()">
    @if (iconSrc()) {
      <img class="mbm-textbox-icon" [src]="iconSrc()!" alt="" aria-hidden="true">
    }
    <ion-input
      class="mbm-textbox-input" [type]="type()" [value]="internalValue()" [disabled]="isDisabled()"
      [placeholder]="placeholderKey() ? (placeholderKey()! | translate) : ''"
      (ionInput)="onInput($event)" (ionBlur)="onBlur()">
    </ion-input>
  </div>
  <mbm-form-error [message]="errorMessage()"></mbm-form-error>
</div>
